
import { CollapseTransition } from 'vue2-transitions'

export default {
  name: 'BaseCollapse',
  components: { CollapseTransition },
  data: () => ({
    isOpen: false
  })
}
